import { render, staticRenderFns } from "./welfare-info.vue?vue&type=template&id=c578fcce&scoped=true"
import script from "./welfare-info.vue?vue&type=script&lang=js"
export * from "./welfare-info.vue?vue&type=script&lang=js"
import style0 from "./welfare-info.vue?vue&type=style&index=0&id=c578fcce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c578fcce",
  null
  
)

export default component.exports